import { BaseAPIRequestFactory, RequiredError } from './baseapi';
import type { Configuration } from '../configuration';
import { RequestContext, HttpMethod, ResponseContext, HttpInfo } from '../http/http';
import { ObjectSerializer } from '../models/ObjectSerializer';
import { ApiException } from './exception';
import { isCodeInRange } from '../util';
import type {SecurityAuthentication} from '../auth/auth';
import type {HttpFile} from '../http/http';



/**
 * no description
 */
export class SamlSSOApiRequestFactory extends BaseAPIRequestFactory {

  /**
   * Initiate SAML SSO with Signed AuthnRequest
   * @param provider Name of the SAML IdP configuration to use   (case-sensitive &#x60;provider_name&#x60;). 
   * @param returnUrl Absolute URL to redirect the user to **after** successful authentication.   Defaults to &#x60;https://&lt;domain&gt;.console.eon.io/home&#x60;. 
   */
  public async samlSso(provider: string, returnUrl?: string, _options?: Configuration): Promise<RequestContext> {
    let _config;
    if (!_options) {
      _config = this.configuration;
    } else {
      _config = Object.assign({}, _options, this.configuration);
    }
    


    // verify required parameter 'provider' is not null or undefined
    if (provider === null || provider === undefined) {
      throw new RequiredError("SamlSSOApi", "samlSso", "provider");
    }



    // Path Params
    const localVarPath = '/saml/sso';

    let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
    // Make Request Context
    const requestContext = _config.baseServer!.makeRequestContext(localVarPath, HttpMethod.GET, signal);
    requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8")

    // Query Params
    if (provider !== undefined) {
      requestContext.setQueryParam("provider", ObjectSerializer.serialize(provider, "string", "tobedefined"));
    }

    // Query Params
    if (returnUrl !== undefined) {
      requestContext.setQueryParam("returnUrl", ObjectSerializer.serialize(returnUrl, "string", "uri"));
    }



    return requestContext;
  }

}

export class SamlSSOApiResponseProcessor {

  /**
   * Unwraps the actual response sent by the server from the response context and deserializes the response content
   * to the expected objects
   *
   * @params response Response returned by the server for a request to samlSso
   * @throws ApiException if the response code was not in [200, 299]
   */
   public async samlSsoWithHttpInfo(response: ResponseContext): Promise<HttpInfo<void >> {
    if (isCodeInRange("204", response.httpStatusCode)) {
      return new HttpInfo(response.httpStatusCode, response.headers, response.body, undefined);
    }
    if (isCodeInRange("302", response.httpStatusCode)) {
      throw new ApiException<undefined>(response.httpStatusCode, "Browser is being redirected to the IdP’s SSO endpoint with a signed AuthnRequest (&#x60;SAMLRequest&#x60;, &#x60;SigAlg&#x60;, &#x60;Signature&#x60; query parameters). ", undefined, response.headers, response);
    }
    if (isCodeInRange("1XX", response.httpStatusCode)) {
      throw new ApiException<undefined>(response.httpStatusCode, "Informational", undefined, response.headers, response);
    }
    if (isCodeInRange("3XX", response.httpStatusCode)) {
      throw new ApiException<undefined>(response.httpStatusCode, "Redirect", undefined, response.headers, response);
    }
    if (isCodeInRange("4XX", response.httpStatusCode)) {
      const body: Error = ObjectSerializer.deserialize(
        await response.body.json(),
        "Error", ""
      ) as Error;
      throw new ApiException<Error>(response.httpStatusCode, "Client Error", body, response.headers, response);
    }
    if (isCodeInRange("5XX", response.httpStatusCode)) {
      const body: Error = ObjectSerializer.deserialize(
        await response.body.json(),
        "Error", ""
      ) as Error;
      throw new ApiException<Error>(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
    }

    // Work around for missing responses in specification, e.g. for petstore.yaml
    if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
      throw new ApiException<string | Blob | undefined>(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
    }
    const body: void = await response.body.json() as void;
    return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
  }

}
